import { render, staticRenderFns } from "./RequestFileAppendButton.vue?vue&type=template&id=1fdd0730&scoped=true&"
import script from "./RequestFileAppendButton.vue?vue&type=script&lang=js&"
export * from "./RequestFileAppendButton.vue?vue&type=script&lang=js&"
import style0 from "./RequestFileAppendButton.vue?vue&type=style&index=0&id=1fdd0730&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd0730",
  null
  
)

export default component.exports